import React from 'react'
import './Heading.css'
import { useGlobalContext } from "../contexts/ImagesContext.js"
function Heading() {
    let {language} = useGlobalContext();
    return (
        <div>
              
        </div>
    )
}

export default Heading
